<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-layout justify-center align-center class="auth-layout">
            <v-flex text-center class="auth-layout__column">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="auth-form"
                    @submit.prevent
                >
                    <div class="title"> Восстановление пароля </div>
                    <v-text-field
                        v-model="password"
                        :rules="rules"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Введите новый пароль"
                        class="grey-input"
                        :error="error"
                        :error-messages="errorMessage"
                        @input="deleteError"
                    >
                        <template v-slot:append>
                            <img
                                width="20"
                                height="20"
                                :src="require('@/assets/icons/eye_icon.svg')"
                                @click="showPassword = !showPassword"
                                v-if="showPassword"
                            >
                            <img
                                width="20"
                                height="20"
                                :src="require('@/assets/icons/eye_closed_icon.svg')"
                                @click="showPassword = !showPassword"
                                v-else
                            >
                        </template>
                    </v-text-field>
                    <v-text-field
                        v-model="confirmPassword"
                        :rules="rules"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        placeholder="Подтвердите пароль"
                        class="grey-input ma-0"
                        :error="error"
                        :error-messages="errorMessage"
                        @input="deleteError"
                    >
                        <template v-slot:append>
                            <img
                                width="20"
                                height="20"
                                :src="require('@/assets/icons/eye_icon.svg')"
                                @click="showConfirmPassword = !showConfirmPassword"
                                v-if="showConfirmPassword"
                            >
                            <img
                                width="20"
                                height="20"
                                :src="require('@/assets/icons/eye_closed_icon.svg')"
                                @click="showConfirmPassword = !showConfirmPassword"
                                v-else
                            >
                        </template>
                    </v-text-field>
                    <v-btn
                        :disabled="!valid"
                        class="auth-btn"
                        @click="validate"
                        type="submit"
                        :class="{'mt-8': error}"
                    >
                        Восстановить пароль
                    </v-btn>
                </v-form>
            </v-flex>
            <v-flex text-center class="auth-layout__column">
                <v-img
                    :src="require('@/assets/images/error.svg')"
                    class="d-inline-flex"
                ></v-img>
            </v-flex>
            <div class="auth-layout__title title"> Восстановление пароля </div>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'SetNewPassword',
    data() {
        return {
            email: null,
            password: null,
            confirmPassword: null,
            valid: true,
            showPassword: false,
            showConfirmPassword: false,
            rules: [value => !!value || 'Обязательное поле'],
            error: null,
            errorMessage: null,
            token: null,
        };
    },
    created() {
        if (this.$route.query.reset_token) {
            this.token = this.$route.query.reset_token;
        } else {
            this.$router.push({ name: "errorpage" });
        }
    },
    methods: {
        setPassword() {
            let url = "/users/hotel-admin/change-password/?reset_token=" + this.token;
            this.$http.put(url, {
                password: this.password
            })
                .then(() => {
                    this.$router.push({ name: "login" });
                })
                .catch((error) => {
                    console.log(error);
                    this.errorMessage = "Ошибка сохранения";
                    this.error = true;
                });
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                if (this.password === this.confirmPassword) {
                    this.setPassword();
                } else {
                    this.error = true;
                    this.errorMessage = "Пароли не совпадают"
                }
            } else {
                this.error = true;
                this.errorMessage = "Обязательное поле";
            }
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>